import type { PylotFrontendConfig } from '../config.d'
export const config: PylotFrontendConfig = {
    base: {
        url: {
            baseUrl: 'https://us.ooka.com/',
            magentoBaseUrl: 'https://mcstaging.hookah-shisha.com/',
            model: {
                category: { directory: 'c', suffix: '' },
                product: { suffix: '.html', directory: 'p' },
                cmsPage: { directory: 'content', suffix: '' },
                blog: { directory: 'blog' }
            },
            externalShishaworldurl: 'https://www.shisha-world.com/',
            mediaBackend: { enabled: true, baseMediaUrl: '' }
        },
        menu: { submenu: 'subcategory', submenu_maxitems: 10 },
        wishlist: {
            enabled: true,
            multiple_wishlists: false,
            multiple_wishlist_number: 5
        },
        yotpo: {
            enabled: false,
            api_key: 'TAI42CJYRPIgVfHWFBUpGsjWFJnNjhiS7O0GY9WZ'
        },
        yotpoLoyalty: {
            enabled: false,
            guid: 'WYqEkIH73B3y6A95ynYXMA',
            widget_ids: {
                checkoutPopup: '90284',
                checkoutRedeem: '90282',
                myAccountPage: ['90290', '90291', '90289', '90292', '90288'],
                rewardsPage: '90285',
                referralsPage: '72234'
            }
        },
        signifyd: { enabled: true },
        landingpage: { enabled: true },
        loqate: {
            enabled: true,
            findEndPoint:
                'https://api.addressy.com/Capture/Interactive/Find/v1.1/json3.ws',
            retrieveEndPoint:
                'https://api.addressy.com/Capture/Interactive/Retrieve/v1.2/json3.ws',
            validateEndPoint:
                'https://api.addressy.com/Cleansing/International/Batch/v1.00/json4.ws',
            api_key: 'DC88-CU47-NX37-MH99'
        },
        spreedlyPaymentMethod: {
            enabled: true,
            environment_key: 'FcnSDHHrqbvNoarHer6WuN9xULf',
            scriptLink: 'https://core.spreedly.com/checkout/sdk/1.6.2/index.js',
            sri:
                'sha384-RIyE3OUuYKNGQTpBRH1lHnuedS6yrvAlQEmprA2tgC4owK+gTfWqFr+8zEMiZN/N'
        },
        klarna: {
            enabled: false,
            scriptLink: 'https://x.klarnacdn.net/kp/lib/v1/api.js',
            allowedCountries: ['DE']
        },
        gReCaptcha: { token: '', enabled: false },
        vr: { enabled: false },
        veratad: { enabled: true },
        reorderAllow: true,
        is_enable_cloudfare_transformation: true,
        socialLogin: {
            google: {
                enabled: false,
                clientId:
                    '907838138612-ee7vdov07o748kak35fp9a128uao414n.apps.googleusercontent.com'
            },
            facebook: { enabled: false, appId: '1322564722031148' }
        },
        restrictedArea: {
            areaCodes: ['UT', 'WA', 'VT', 'ME', 'SD', 'DC', 'AR'],
            cbdAreaCodes: [
                'ID',
                'CO',
                'NJ',
                'CA',
                'VA',
                'AR',
                'HI',
                'KS',
                'LA',
                'OK',
                'OR',
                'RI',
                'UT',
                'VT',
                'APO'
            ]
        },
        sentry: {
            enabled: true,
            dsn:
                'https://f6b6fc5c82992611829c3a2cbea0abb5@o4510222596440064.ingest.de.sentry.io/4510312710668368'
        },
        magentoBaseUrl: 'https://mcadmin.ooka.com/',
        googleSiteVerificationContent:
            'aKLx5LfHzq51tGorZCQuVjcpiQERJ3Cg1X8OAQ76W28',
        otherWebsiteUrls: {
            ooka_us: 'https://us.ooka.com/',
            ooka_ae: 'https://me.ooka.com/',
            ooka_de: 'https://de.ooka.com/',
            ooka_glp: 'https://ooka.com/'
        },
        route: { cms_no_route: 'no-route', cms_home_page: 'home' },
        youtubeData: {
            api_key: 'AIzaSyAsmeUQMhHEM7TiFTEvnJJ8rpfdx_iG5HA',
            playlistBaseUrl:
                'https://www.googleapis.com/youtube/v3/playlistItems',
            videoBaseUrl: 'https://www.googleapis.com/youtube/v3/videos'
        },
        hubspot: {
            enabled: false,
            portalId: '25636661',
            formId: '435c7909-498b-4f03-927a-e191fe320f70',
            chatUrl: '//js-eu1.hs-scripts.com/25636661.js'
        },
        googleAnalytics: { containerID: 'UA-941895-9' },
        canonical: true
    },
    preload: {
        menu: {
            queryPath:
                'framework/pylot/hooks/category/graphql/navigationMenuWithCMSBlocks.ts',
            variables: { category_uid: 'MTEzMw==', onlyTopLevel: true }
        },
        header: {
            variables: {
                identifiers: ['shipping-promo-banner', 'legal-requirement']
            },
            queryPath: 'framework/pylot/hooks/cms/graphql/getCMSBlocks.ts'
        },
        footer: {
            variables: {
                identifiers: [
                    'footer-copyright-block',
                    'footer_links',
                    'footer-social-media',
                    'unique-selling-proposition-slider',
                    'footer-secure-payment'
                ]
            },
            queryPath: 'framework/pylot/hooks/cms/graphql/getCMSBlocks.ts',
            role: {
                copyright: 'footer-copyright-block',
                links: 'footer_links',
                social: 'footer-social-media',
                unique: 'unique-selling-proposition-slider',
                securePayment: 'footer-secure-payment'
            }
        },
        countries: {
            variables: {},
            queryPath:
                'components/alfakher/pylot-utils/src/hooks/graphql/countryQuery.ts'
        },
        checkoutBlocks: {
            variables: {
                identifiers: [
                    'checkout_alfa_consent',
                    'account_creation_benefit',
                    'checkout_review_block',
                    'checkout_age_verfication_message',
                    'CheckoutAgreements',
                    'checkout_guest_info',
                    'footer-copyright-block-checkout',
                    'checkout_customer_info'
                ]
            },
            queryPath: 'framework/pylot/hooks/cms/graphql/getCMSBlocks.ts'
        },
        blogBlocks: {
            variables: {
                identifiers: [
                    'sidebar-banner-1',
                    'blog_shop_now',
                    'you_may_also_like'
                ]
            },
            queryPath: 'framework/pylot/hooks/cms/graphql/getCMSBlocks.ts'
        },
        MyDevice: {
            variables: { identifiers: [] },
            queryPath: 'framework/pylot/hooks/cms/graphql/getCMSBlocks.ts'
        },
        CheckoutAgreements: {
            variables: {},
            queryPath:
                'framework/pylot/hooks/cms/graphql/getCheckoutAgreement.ts'
        },
        thca_disclaimer: {
            variables: { identifiers: ['thca_disclaimer'] },
            queryPath: 'framework/pylot/hooks/cms/graphql/getCMSBlocks.ts'
        },
        GiftWrapping: { isEnabled: false, identifiers: ['gift_cart_Message'] }
    },
    seo: {
        default: {
            title: 'Ooka USA',
            titleTemplate: 'Ooka USA Storefront | %s',
            description: 'Ooka USA',
            openGraph: {
                type: 'website',
                locale: 'en_US',
                url: 'https://us.ooka.com/en/',
                site_name: 'Ooka USA',
                images: [
                    {
                        url:
                            'https://mcadmin.ooka.com/media/wysiwyg/logo/OokaLogo.png',
                        alt: 'Ooka USA'
                    }
                ]
            },
            twitter: {
                handle: '@ooka',
                site: 'Ooka USA',
                cardType: 'summary_large_image'
            }
        },
        product: {
            attributes: {
                name: ['name'],
                description: ['description', 'html'],
                image: ['media_gallery', '0', 'url'],
                price_amount: [
                    'price_range',
                    'minimum_price',
                    'final_price',
                    'value'
                ],
                price_currency: [
                    'price_range',
                    'minimum_price',
                    'final_price',
                    'currency'
                ],
                review_count: ['review_count'],
                review_summary: ['review_summary'],
                gtin: ['gtin'],
                brand: ['brand'],
                manufacturer: ['manufacturer'],
                model: ['model'],
                sku: ['sku'],
                mpn: ['mpn'],
                seller: ['seller'],
                alternate_name: ['alternate_name']
            },
            image: {
                count: 1,
                width: 620,
                placeholder:
                    'https://media.ooka.com/media/wysiwyg/placeholder/Ooka-Image-Coming-Soon.jpg'
            },
            description: {
                regExp: '^[\\n|\\n\\r]+Details[\\n|\\n\\r]+',
                maxLength: 1000
            },
            price: { currency: 'USD', precision: 2, validUntilDays: 14 },
            defaultBrand: 'Ooka Products',
            bestRating: 5
        },
        organization: {
            content: {
                '@context': 'https://schema.org',
                '@type': 'Organization',
                legalname: 'Ooka',
                address: {
                    '@type': 'PostalAddress',
                    streetAddress: '3727 Drossett Drive',
                    addressLocality: 'Austin',
                    addressRegion: 'Texas',
                    postalCode: '78744'
                },
                url: 'https://us.ooka.com/en/',
                logo: 'https://media.ooka.com/media/wysiwyg/logo/OokaLogo.png',
                name: 'Ooka',
                email: 'Info@ooka.com',
                contactPoint: [
                    {
                        telephone: '866-466-5247',
                        contactType: 'customer service',
                        contactOption: 'TollFree'
                    }
                ],
                sameAs: [
                    'https://www.instagram.com/hookah_shisha',
                    'https://www.youtube.com/user/hookahANDshisha',
                    'https://www.facebook.com/HOOKAHdashSHISHA',
                    'https://twitter.com/hookah_shisha'
                ]
            },
            allowedPath: '/'
        },
        customPages: {
            account: {
                pageName: 'My Account',
                pageType: 'account',
                children: {
                    orders: {
                        pageName: 'My Account | Orders',
                        pageType: 'account-orders'
                    },
                    wishlist: {
                        pageName: 'My Account | Wishlist',
                        pageType: 'account-wishlist'
                    },
                    address: {
                        pageName: 'My Account | Address',
                        pageType: 'account-address'
                    },
                    'account-information': {
                        pageName: 'My Account | Account Information',
                        pageType: 'account-information'
                    },
                    'store-credit': {
                        pageName: 'My Account | Store Credit',
                        pageType: 'account-store-credit'
                    },
                    newsletter: {
                        pageName: 'My Account | Newsletter Subscription',
                        pageType: 'account-newsletter'
                    },
                    'gift-card': {
                        pageName: 'My Account | Gift Card',
                        pageType: 'account-gift-card'
                    }
                }
            },
            search: { pageName: 'Search page', pageType: 'searchresults' },
            checkout: { pageName: 'Checkout page', pageType: 'checkout' }
        },
        checkoutSteps: {
            cart: 1,
            login: 2,
            signup: 2,
            shipping: 3,
            payment: 4
        },
        tagManager: { gtm: { enabled: true, containerId: 'GTM-MDSWBSMD' } },
        searchBox: {
            allowedPath: '/',
            potentialActions: [
                {
                    target: 'https://us.ooka.com/en/search?q',
                    queryInput: 'search_term_string'
                }
            ]
        }
    },
    static: {
        categories: { count: 100, root: 'ooka-usa' },
        products: { count: 100 }
    },
    is_fallback: false
}
